import { createSelector } from 'reselect';
import { confirmationModalOpen } from './confirmationModalReducer';
import { RootState } from '..';

export const getconfirmationModalState = (state: RootState) => state.confirmationModal;

export const getconfirmationModalStateData = (state: RootState) => state.formState;

export const getconfirmationModalIsOpen = createSelector(getconfirmationModalState, confirmationModalOpen);
